import { useContext } from 'react';

import { MFSurveyFormContext } from '../providers/MFSurveyFormProvider';

export const useMFSurveyFormContext = () => {
  const context = useContext(MFSurveyFormContext);

  if (!context) {
    throw new Error('useMFSurveyFormContext must be used within an MFSurveyFormProvider');
  }

  return context;
};
